module.exports = __webpack_public_path__ + "img/centro-de-carga.c25981d8.png";